export default __webpack_public_path__ + "16501b4a5118eecba52bce47e9ef1198.svg";